module.exports = __webpack_public_path__ + "static/media/woman.2751915f.png";